import { Card, CardBody, CardFooter, Grid, Link, Tag, TagGroup, Text } from '@backstage/ui';
import { ScaffolderField } from '@backstage/plugin-scaffolder-react/alpha';
import type { AppBlueprintPickerProps, BlueprintOption } from './schema';
import styles from './AppBlueprintPicker.module.css';

const AppBlueprintPicker = (props: AppBlueprintPickerProps) => {
  const {
    schema: { title = 'App blueprint' },
    onChange,
    rawErrors,
    required,
    formData,
    errors,
    uiSchema,
  } = props;

  const items = (uiSchema?.['ui:options']?.items ?? []) as BlueprintOption[];

  return (
    <ScaffolderField rawErrors={rawErrors} required={required} errors={errors}>
      <div role="radiogroup" aria-label={title}>
        <Grid.Root columns={{ initial: '1', md: '3' }} gap="4" mt="2">
          {items.map(item => {
            const isSelected = formData === item.value;

            return (
              <Grid.Item key={item.value}>
                <Card
                  className={isSelected ? `${styles.card} ${styles.cardSelected}` : styles.card}
                >
                  <CardBody>
                    <button
                      type="button"
                      role="radio"
                      aria-checked={isSelected}
                      className={styles.cardButton}
                      onClick={() => onChange(item.value)}
                    >
                      <Text variant="title-x-small">{item.label}</Text>
                      <Text variant="body-medium" color="primary" className={styles.description}>
                        {item.description}
                      </Text>
                    </button>
                  </CardBody>
                  <CardFooter className={styles.cardFooter}>
                    <Link
                      href={item.readmeUrl}
                      target="_blank"
                      rel="noreferrer"
                      variant="body-small"
                    >
                      View blueprint README
                    </Link>
                    {item.tags?.length ? (
                      <TagGroup aria-label={`${item.label} tags`}>
                        {item.tags.map(tag => (
                          <Tag key={tag} size="small">
                            {tag}
                          </Tag>
                        ))}
                      </TagGroup>
                    ) : null}
                  </CardFooter>
                </Card>
              </Grid.Item>
            );
          })}
        </Grid.Root>
      </div>
    </ScaffolderField>
  );
};

export default AppBlueprintPicker;
